import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=476f6d00&scoped=true"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=476f6d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f6d00",
  null
  
)

export default component.exports